import commonFilesStore from '@/store/common-modules/files';

export default {
  namespaced: true,
  modules: {
    commonFilesStore,
  },
};
